// EditBarcode.tsx
import DynamicDataSelectorInput from "@builder/components/general/DynamicSelectorInput";
import SelectInput from "@builder/components/general/SelectInput";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { SupportedBarcodeTypes } from "@common/build/constants";
import { BarcodeNode } from "@common/build/types";
import { useState } from "react";
import { updateNodeProperty } from "../../../../store/slices/BuilderSlice/builderSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import SidebarCollapse from "../../../app/SidebarCollapse";
import RadioInput from "../../../general/RadioInput";
import TextInput from "../../../general/TextInput";
import { EditableProps } from "../../editableProps";
import Toggle from "@builder/components/general/Toggle";
import "./styles.scss";

import OliverText from "@builder/components/general/OliverText";
import EditableInfo from "../../EditableInfo";

import useBarcodeGenerator from "@builder/hooks/useBarcodeGenerator";

const EditBarcode: React.FC<EditableProps> = ({ parent }: EditableProps) => {
    const dispatch = useAppDispatch();
    const [error, setError] = useState<string>("");
    const selectedNode = useAppSelector(getSelectedNode) as BarcodeNode;
    const [textType, setTextType] = useState<string>(selectedNode.dynamicData ? "db" : "static");

    useBarcodeGenerator(textType, setError);

    const textTypeOptions = [
        { value: "static", img: "/static-text-icon.svg", checked: textType === "static", tooltip: "Static" },
        { value: "db", img: "/db-icon.svg", checked: textType === "db", tooltip: "Dynamic" }
    ];

    const textTypeCallback = (value: string): void => {
        setTextType(value);
    };

    return (
        <SidebarCollapse title="Barcode" parent={parent}>
            <RadioInput groupName="textType" options={textTypeOptions} callback={textTypeCallback}></RadioInput>
            {textType === "static" ? (
                <TextInput
                    title="Barcode"
                    value={selectedNode?.barcode?.content || ""}
                    placeholder="Enter text"
                    callback={value => dispatch(updateNodeProperty({ propertyPath: ["barcode"], value: { content: value } }))}
                />
            ) : (
                <>
                    <DynamicDataSelectorInput />
                    <EditableInfo header="Warning" body="Barcode dynamic data warning" />

                    <TextInput
                        title="Prepend"
                        value={selectedNode?.barcode?.prepend}
                        placeholder="Enter text"
                        callback={value => dispatch(updateNodeProperty({ propertyPath: ["barcode"], value: { prepend: value } }))}
                    />

                    <TextInput
                        title="Append"
                        value={selectedNode?.barcode?.append}
                        placeholder="Enter text"
                        callback={value => dispatch(updateNodeProperty({ propertyPath: ["barcode"], value: { append: value } }))}
                    />
                </>
            )}
            <SelectInput
                value={selectedNode?.barcode?.bcid || "choose a barcode type"}
                title="Barcode Type"
                options={SupportedBarcodeTypes}
                callback={value => dispatch(updateNodeProperty({ propertyPath: ["barcode"], value: { bcid: value } }))}
                layout="column"
                noTranslate
            />

            {selectedNode?.barcode?.content && !(selectedNode?.barcode?.bcid && ["microqrcode", "qrcode"].includes(selectedNode?.barcode?.bcid)) && (
                <Toggle
                    label="Show Text"
                    checked={selectedNode?.barcode?.displayText || false}
                    callback={value => dispatch(updateNodeProperty({ propertyPath: ["barcode"], value: { displayText: value } }))}
                />
            )}

            {error && textType === "static" && <OliverText text={error} size="xs" weight="medium" color="red" />}
        </SidebarCollapse>
    );
};

export default EditBarcode;
